import React, { useEffect, useState } from "react";
import { ReportAPI } from "../../api/apiClient";

interface LedgerRow {
  voucher: string;
  opening: number;
  debit: number;
  closing: number;
}

export default function SiteCashPaymentsDashboardCard({
  projectId,
}: {
  projectId: number;
}) {
  const [rows, setRows] = useState<LedgerRow[]>([]);
  const [opening, setOpening] = useState(0);
  const [closing, setClosing] = useState(0);
  const [totalDebit, setTotalDebit] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const result =
          await ReportAPI.getSiteCashPaymentsDashboard({
            project: projectId,
            ledger: 0,
          });

        if (result.success) {
          setRows(result.data ?? []);
          setOpening(result.opening ?? 0);
          setClosing(result.closing ?? 0);
          setTotalDebit(result.totalDebit ?? 0);
        } else {
          setRows([]);
        }
      } catch (error) {
        console.error("Dashboard error:", error);
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, [projectId]);

  return (
    <div className="bg-white rounded-xl shadow-md border h-full">

      {/* HEADER */}
      {/*<div className="bg-blue-700 text-white px-4 py-2 rounded-t-xl font-semibold text-sm">*/}
      <div className="bg-[#1788ac] text-white px-4 py-2 rounded-t-xl font-semibold text-sm">
        SITE CASH PAYMENTS
      </div>

      {/* CONTENT */}
      <div className="px-4 py-4 text-sm">

        {loading && (
          <div className="text-gray-500 text-center">
            Loading...
          </div>
        )}

        {!loading && rows.length > 0 && (
          <div className="space-y-2">

            {/* Opening */}
            <div className="flex justify-between text-gray-600">
              <span>Opening</span>
              <span className="font-medium">
                {opening.toFixed(2)}
              </span>
            </div>

            {/* Vendor List */}
            <div className="max-h-32 overflow-y-auto border-t pt-2 space-y-1">
              {rows.map((row, index) => (
                <div
                  key={index}
                  className="flex justify-between py-1 hover:bg-gray-50 rounded px-1"
                >
                  <span className="text-gray-700 text-xs truncate">
                    {row.voucher}
                  </span>
                  <span className="text-red-600 text-xs">
                    {row.debit.toFixed(2)}
                  </span>
                </div>
              ))}
            </div>

            {/* Total Debit */}
            <div className="border-t pt-2 flex justify-between font-bold text-gray-800">
              <span>Total Debit</span>
              <span>{totalDebit.toFixed(2)}</span>
            </div>

            {/* Closing */}
            <div className="flex justify-between font-semibold text-green-600">
              <span>Closing</span>
              <span>{closing.toFixed(2)}</span>
            </div>

          </div>
        )}

        {!loading && rows.length === 0 && (
          <div className="text-gray-400 text-xs text-center py-4">
            No payments recorded for latest DRS
          </div>
        )}
      </div>
    </div>
  );
}